import useNetwork from '@/hooks/useNetwork';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import { parse } from 'query-string';

export default function useQuery(props) {
  const {
    location = {},
    PAGE_SIZE = 0, // 0 = count only: server returns metadata but no record data
    returnCsvQuery = false
  } = props;

  const network = useNetwork();

  const query = {
    where: {
      filter: { intent: 'educator', networkId: network?.id, stars: 'any' }
    },
    pagination: returnCsvQuery ? undefined : {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc',
    },
    exclude: function (model) {
      return model.state === PayloadStates.DELETED;
    }
  }

  const result = useConnect('user.find', query, {
    enabled: !returnCsvQuery,
    keepPreviousData: true
  });

  if (returnCsvQuery) {
    return query;
  }

  return result
}
